module.exports = __webpack_public_path__ + "fonts/SFUIText-SemiboldItalic.5832d550.ttf";